import { configureStore  } from '@reduxjs/toolkit';
import thunk from 'redux-thunk'
import taskReducer from './slices/tasksReducer'
import notificationReducer from './slices/notificationReducer'
import viewModeReducer from './slices/viewModeReducer'
import userReducer from './slices/userReducer'
import userLocationReducer from './slices/locationReducer'
import modalReducer from './slices/modalReducer'
import alertReducer from './slices/alertReducer'
import carrouselReducer from './slices/carrouselReducer'
import domainsReducer from './slices/domainsReducer'
import formsReducer from './slices/formsReducer'

export default configureStore({
  reducer: {
    tasks: taskReducer,
    notifications: notificationReducer,
    viewMode: viewModeReducer,
    user: userReducer,
    userLocation: userLocationReducer,
    modal: modalReducer,
    alert: alertReducer,
    carrousel: carrouselReducer,
    domains: domainsReducer,
    forms: formsReducer,
  },
  middleware: [thunk]
});
